import { ReactNode } from 'react'
import styled from 'styled-components'

export const MainBox = ({ content }: { content?: ReactNode }) => {
  return (
    <MainBoxRoot>
      <Box>{content && content}</Box>
      <ArrowDown />
    </MainBoxRoot>
  )
}

const MainBoxRoot = styled.div`
  position: relative;
  text-align: center;
  margin-bottom: 90px;
  margin-top: 90px;
  width: 100% !important;
  max-width: calc(100vw - 40px);
  span {
    font-size: 30px !important;
    line-height: 1.4em !important;  color: var(--chapter-text);

  }
`

const Box = styled.div`
  background-color: var(--chapter-bg);
  /* max-width: 400px; */
  margin-left: auto;
  margin-right: auto;
  padding: 30px;
  padding-bottom: 40px;
`

const ArrowDown = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15px;
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 15px solid var(--chapter-bg);
`
